import { create } from 'zustand';

const state = { status: null, title: '', description: '', useCounter: false, detailMessage: [], alwaysShow: false };

export const useSnackbarNotification = create((set) => ({
    ...state,
    onChangeSnackbarNotification: (newState) => set((state) => ({ ...state, ...newState })),
    onResetSnackbarNotification: () => set(() => ({ ...state })),
}));
